import React from "react";
import EditStudentProfile from "./EditStudentProfile/EditStudentProfile";

const EditProfile = () => {
  return (
    <>
      <EditStudentProfile />
    </>
  );
};

export default EditProfile;
